import {apiClient} from '../../core/api/client';
import {membershipPdfFilename} from '../../../utils/reportFilename';

/** Fetch once through the original endpoint; retain its filename for preview downloads. */
export async function loadMembershipPdf(request: unknown, signal?: AbortSignal): Promise<Blob> {
    const response = await apiClient.post<Blob>('/api/report/membership/exportMembershipPdf', request, {
        signal, responseType: 'blob', timeout: 300000,
        headers: {Accept: 'application/pdf'},
    });
    const disposition = String(response.headers?.['content-disposition'] || '');
    const encoded = disposition.match(/filename\*=UTF-8''([^;\n]*)/i);
    const plain = disposition.match(/filename="([^"]+)"/i);
    const filename = encoded ? decodeURIComponent(encoded[1]) : plain?.[1] || membershipPdfFilename();
    return new File([response.data], filename, {type: 'application/pdf'});
}
